"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeBlock = void 0;
var slate_1 = require("slate");
var EditorTypes_1 = require("../EditorTypes");
var Table_1 = require("ContentTokens/DataModels/Table");
var SchemaType_1 = require("./SchemaType");
var TokenModels_1 = __importDefault(require("ContentTokens/TokenModels"));
var NormalizeVoidNode_1 = require("./NormalizeVoidNode");
var Utils_1 = require("../Utils");
var lodash_1 = require("lodash");
var EditorWidgetRegistry_1 = require("Project/QwilrEditor/WidgetRegistry/EditorWidgetRegistry");
var CommonWidgetRegistry_1 = require("@CommonFrontend/WidgetRegistry/CommonWidgetRegistry");
var normalizeBlock = function (_a, editor, schema) {
    var _b, _c;
    var _d = __read(_a, 2), node = _d[0], path = _d[1];
    if ((0, EditorWidgetRegistry_1.isResizeableWidget)(node)) {
        var width = node.data.width;
        var height = node.data.height;
        var resizeableConfiguration = (0, CommonWidgetRegistry_1.getTraitConfig)({ widgetType: node.type, traitName: "resizeable" });
        if (typeof width === "undefined") {
            var nextData = (0, lodash_1.cloneDeep)(node.data);
            nextData.width = resizeableConfiguration.width.default;
            slate_1.Transforms.setNodes(editor, { data: nextData }, { at: path });
            return true;
        }
        if (typeof height === "undefined" && resizeableConfiguration.height) {
            var nextData = (0, lodash_1.cloneDeep)(node.data);
            nextData.height = resizeableConfiguration.height.default;
            slate_1.Transforms.setNodes(editor, { data: nextData }, { at: path });
            return true;
        }
        if (typeof width === "string" && width !== "content") {
            var parentEntry = slate_1.Editor.parent(editor, path);
            var _e = __read(parentEntry, 1), parentNode = _e[0];
            if (!slate_1.Editor.isEditor(parentNode)) {
                var parentConfig = (0, EditorWidgetRegistry_1.getGenericConfigByType)(parentNode.type, true);
                if (!((_b = parentConfig === null || parentConfig === void 0 ? void 0 : parentConfig.containerNodeConfiguration) === null || _b === void 0 ? void 0 : _b.supportWideWidgets)) {
                    var nextData = (0, lodash_1.cloneDeep)(node.data);
                    nextData.width = resizeableConfiguration.width.custom ? 100 : "content";
                    slate_1.Transforms.setNodes(editor, { data: nextData }, { at: path });
                    return true;
                }
            }
        }
    }
    if ((0, EditorWidgetRegistry_1.isAlignableWidget)(node)) {
        var alignment = node.data.alignment;
        var alignableConfiguration = (0, CommonWidgetRegistry_1.getTraitConfig)({ widgetType: node.type, traitName: "alignable" });
        if (typeof alignment === "undefined") {
            var nextData = (0, lodash_1.cloneDeep)(node.data);
            nextData.alignment = alignableConfiguration.defaultAlignment;
            slate_1.Transforms.setNodes(editor, { data: nextData }, { at: path });
            return true;
        }
    }
    var editorRegistryNormalizerResult = (_c = (0, EditorWidgetRegistry_1.getGenericConfigByType)(node.type, true)) === null || _c === void 0 ? void 0 : _c.normalizeWidget(node, path, editor, schema);
    if (!(0, lodash_1.isUndefined)(editorRegistryNormalizerResult)) {
        return editorRegistryNormalizerResult;
    }
    if (schema.blocks[node.type] == undefined) {
        return false;
    }
    switch (node.type) {
        case EditorTypes_1.BlockType.TableDummy:
        case EditorTypes_1.BlockType.TableCell:
            return normalizeBasicBlock(node, path, editor, schema);
        case EditorTypes_1.BlockType.Table:
            return normalizeTable(node, path, editor);
        case EditorTypes_1.BlockType.TableRow:
        case EditorTypes_1.BlockType.TableRepeatingRow:
            return normalizeTableRow(node, path, editor, schema);
    }
    return false;
};
exports.normalizeBlock = normalizeBlock;
var normalizeBasicBlock = function (node, path, editor, schema) {
    var blockConfig = schema.blocks[node.type];
    if (!blockConfig) {
        return false;
    }
    if (blockConfig.isVoid) {
        return (0, NormalizeVoidNode_1.normalizeVoidNode)(node, path, editor);
    }
    else {
        return normalizeBlockChildren(node, path, editor, schema);
    }
};
var normalizeBlockChildren = function (node, path, editor, schema) {
    var _a;
    var blockSchema = schema.blocks[node.type];
    var validChildren = blockSchema.validChildren;
    for (var i = 0; i < node.children.length; i++) {
        var currChild = node.children[i];
        if (!slate_1.Text.isText(currChild) &&
            ((0, EditorWidgetRegistry_1.getGenericConfigByType)(currChild.type)
                ?
                    !((_a = (0, EditorWidgetRegistry_1.getGenericConfigByType)(currChild.type)) === null || _a === void 0 ? void 0 : _a.validContainers.includes(node.type))
                :
                    !validChildren.includes(currChild.type))) {
            slate_1.Transforms.unwrapNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false), voids: true });
            return true;
        }
        if ((0, SchemaType_1.isContainerBlockSchema)(blockSchema) && slate_1.Text.isText(currChild)) {
            slate_1.Transforms.delete(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false) });
            return true;
        }
    }
    if (node.children.length < 1) {
        var createTextNode = function () { return TokenModels_1.default.text.createSlateJson(""); };
        var createDefaultChildNode = (0, SchemaType_1.isContainerBlockSchema)(blockSchema)
            ? blockSchema.createDefaultChildNode
            : createTextNode;
        var defaultChild = createDefaultChildNode();
        slate_1.Transforms.insertNodes(editor, defaultChild, { at: __spreadArray(__spreadArray([], __read(path), false), [0], false) });
        return true;
    }
    return false;
};
var normalizeTable = function (node, path, editor) {
    if (!node.children.length || node.children[0].type !== EditorTypes_1.BlockType.TableDummy) {
        var newDummy = (0, Table_1.createTableDummyNode)();
        slate_1.Transforms.insertNodes(editor, newDummy, { at: __spreadArray(__spreadArray([], __read(path), false), [0], false) });
        return true;
    }
    for (var i = 1; i < node.children.length; i++) {
        if (node.children[i].type !== EditorTypes_1.BlockType.TableRow && node.children[i].type !== EditorTypes_1.BlockType.TableRepeatingRow) {
            slate_1.Transforms.removeNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false) });
            return true;
        }
    }
    if (node.children.length === 1) {
        slate_1.Transforms.insertNodes(editor, (0, Table_1.createEmptyTableRowNode)(), { at: __spreadArray(__spreadArray([], __read(path), false), [1], false) });
        return true;
    }
    return false;
};
function normalizeTableRow(node, path, editor, schema) {
    var table = (0, Utils_1.checkAncestors)(editor, path, function (c) { return slate_1.Element.isElement(c) && c.type === EditorTypes_1.BlockType.Table; });
    if (table) {
        if (node.children.length < table[0].data.columns) {
            slate_1.Transforms.insertNodes(editor, (0, Table_1.createEmptyTableCellNode)(), { at: __spreadArray(__spreadArray([], __read(path), false), [node.children.length], false) });
            return true;
        }
    }
    return normalizeBasicBlock(node, path, editor, schema);
}
